import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgGift = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 25 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <mask
      id='gift_svg__a'
      width={18}
      height={20}
      x={3}
      y={2}
      maskUnits='userSpaceOnUse'
      style={{
        maskType: 'alpha',
      }}
    >
      <path
        fill={props.color}
        d='M7.234 21.426c-1.67 0-2.61-.914-2.61-2.575v-5.168H4.58c-.756-.246-1.142-.923-1.142-1.916v-2.17c0-1.284.747-2.066 1.977-2.066H6.76a2.68 2.68 0 0 1-.756-1.899c0-1.775 1.433-3.058 3.208-3.058 1.345 0 2.496.773 2.918 2.135.422-1.362 1.573-2.135 2.918-2.135 1.766 0 3.2 1.283 3.2 3.058 0 .756-.282 1.407-.757 1.899h1.345c1.266 0 1.978.782 1.978 2.065v2.171c0 .993-.387 1.67-1.143 1.916h-.044v5.168c0 1.661-.932 2.575-2.602 2.575zm3.982-13.895V6.388c0-1.204-.809-2.013-1.802-2.013-.94 0-1.564.572-1.564 1.486 0 .94.755 1.67 2.083 1.67zm1.82 0h1.291c1.319 0 2.074-.73 2.074-1.67 0-.914-.624-1.486-1.555-1.486-.994 0-1.81.81-1.81 2.013zm-1.873 4.57V9.253h-5.22c-.405 0-.58.185-.58.59v1.67c0 .403.175.588.58.588zm1.925 0h5.23c.404 0 .57-.158.57-.562V9.842c0-.404-.166-.589-.57-.589h-5.23zm-1.925 7.559v-5.828H6.55v4.8c0 .65.378 1.028 1.046 1.028zm1.925 0h3.568c.668 0 1.046-.378 1.046-1.029v-4.799h-4.614z'
      />
    </mask>
    <g mask='url(#gift_svg__a)'>
      <path fill={props.color} d='M.125 0h24v24h-24z' />
    </g>
  </svg>
)
const ForwardRef = forwardRef(SvgGift)
export default ForwardRef
